import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useTitle } from 'react-use';

import { SettingsContent } from '@/components/templates/SettingsContent/SettingsContent';
import { usePermissions } from '@/hooks/usePermissions';
import { useCanReadUsage } from '@/modules/billing/hooks/useVoiceUsage';
import { selectAccountSlug } from '@/redux/session/selectors';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

import { VoiceUsage } from './VoiceUsage';

/** Billed voice minutes per carrier and call, for billing and analytics readers. */
const Usage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const slug = useSelector(selectAccountSlug);
  const { listStatus } = usePermissions();
  const canReadPage = useCanReadUsage();

  useTitle(t('pages.usage'));
  useSegments(PageName.USAGE);

  if (listStatus === 'success' && !canReadPage) {
    navigate(`/${slug}/account/information`);
    return null;
  }

  return (
    <SettingsContent fill className="overflow-y-auto">
      <h1 className="mb-4 text-lg leading-none font-semibold tracking-[-0.45px] text-foreground">
        {t('pages.usage')}
      </h1>
      <VoiceUsage />
    </SettingsContent>
  );
};

export default Usage;
